import { HomeFooter } from "homepage/homeFooter";
import { Header } from "homepage/homeHeader";
import React from "react";

const AfterRegistration = () => {
  return (
    <>
      <Header />

      <div className="d-flex justify-content-center align-items-center "  style={{ minHeight: "46vh"}}>
        <div className="text-center mb-4">
          <div className="card shadow-lg p-4" style={{ maxWidth: "600px" }}>
            <h3 className="text-center mb-1">
              <span className="position-relative fw-bold z-1">
                Confirm Registration
                <img
                  src="../../assets/img/front-pages/icons/section-title-icon.png"
                  alt="laptop charging"
                  className="section-title-img position-absolute object-fit-contain bottom-0 z-n1"
                />
              </span>
              <br />
            </h3>
            <p>
              {" "}
              Great! You are only a few steps away! We have just sent a
              verification request to the email you have provided. Please check
              your email and click on the link shared. If you don’t find it in
              your inbox, please check your spam folder.
            </p>
          </div>
        </div>
      </div>
      <HomeFooter />
    </>
  );
};

export default AfterRegistration;
